import React from 'react';
import { graphql } from 'react-relay';
import { useFragment } from 'react-relay/hooks';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import clsx from 'clsx';
import { PollHeader_data$key } from './__generated__/PollHeader_data.graphql';
import classes from './PollHeader.module.scss';
import CrossIcon from '../../assets/CrossIcon';
import Txt from '../../atoms/Txt/Txt';

export interface Props {
  pollRef: PollHeader_data$key;
  open?: boolean;
  displayTime?: number | null;
}

const fragmentSpec = graphql`
  fragment PollHeader_data on PollQuestion {
    id
    description {
      title
    }
    reward {
      formatted
    }
    startDate
  }
`;

const PollHeader: React.FC<Props> = ({ displayTime, pollRef, open }) => {
  const poll = useFragment(fragmentSpec, pollRef);

  const live = poll.startDate ? new Date(poll.startDate) < new Date() : false;
  dayjs.extend(calendar);

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.banner, open && classes.openBanner, !live && classes.upcomingQuiz)}
      >
        {displayTime || '?'}
        <svg
          className={classes.frame}
          preserveAspectRatio="none"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path id="frame" fill="currentColor" d="M0 80C34 106 66 106 100 80V100H50H0V80Z" />
        </svg>
      </div>
      <div className={classes.info}>
        <div className={classes.date}>
          {!live && poll.startDate && <p>{dayjs(poll.startDate).calendar()}</p>}
          {!open && live && <Txt component="p">Live now!</Txt>}
        </div>
        {!open && live && <p className={classes.reward}>{poll.reward?.formatted}</p>}
      </div>
    </div>
  );
};

export default PollHeader;
